import React from 'react'
import { Col, Card } from 'react-bootstrap'
import { graphql, useStaticQuery } from 'gatsby'
import Scroller from './scroller'
import Image from 'gatsby-image'
const BoxCliente = ({ data }) => {
    const { tipo, imagen, descripcion } = data;
    const { clientes: { nodes: listadoImagenes } } = useStaticQuery(getImagenes);
    const tipoCliente = listadoImagenes.filter(img => img.tipo.fluid.originalName === imagen)
    return (
        <Col sm={6} md={6} lg={3} className="mb-3">
            <Card className="no-bradius">
                <div className="p-4">
                    <div className="img-tipo">
                        <Image fluid={tipoCliente[0].tipo.fluid} />
                    </div>
                </div>
                <Card.Body className="py-4" style={{ background: '#f4f4f4' }}>
                    <h4 className={`mt-2 mb-4  text-center font-weight-bold letra-${tipo.replace(' ', '-').toLowerCase()}`}>{tipo}</h4>
                    <p className="text-center">{descripcion}</p>
                </Card.Body>

            </Card>
            <a className="js-scroll-trigger btn-solucion" href={`#${tipo.replace(' ', '-').toLowerCase()}`} onClick={Scroller.handleAnchorScroll}>
                Ver productos
                    </a>
        </Col>
    )
}

export default BoxCliente

const getImagenes = graphql`
{
    clientes:allFile(filter: {sourceInstanceName: {eq: "productos"}}) {
        nodes {
            tipo:childImageSharp {
                fluid {
                    ...GatsbyImageSharpFluid
                    originalName
                }
            }
        }
    }
}
`
